import { useCallback, useContext } from "react";
import { BehaviourContext } from "../context/AppStore";
const useBehaviourContext: any = () => {
   const [state, setState] = useContext(BehaviourContext);

   const setExtraLeftPanel: any = useCallback((expand: string) => {
      setState((prvState: any) => ({ ...prvState, showExtraLeftPanel: expand }));
   }, [setState]);
   const setExpandLeftPanel: any = useCallback((expand: boolean) => {
      setState((prvState: any) => ({ ...prvState, expandLeftPanel: expand }));
   }, [setState]);
   const setShowSearchPanel: any = useCallback((expand: boolean) => {
      setState((prvState: any) => ({ ...prvState, showSearchPanel: expand }));
   }, [setState]);
   const setFilterTopNav: any = useCallback((expand: boolean) => {
      setState((prvState: any) => ({ ...prvState, isFilterTopNav: expand }));
   }, [setState]);
   const setSearchText: any = useCallback((searchterm: string) => {
      setState((prvState: any) => ({ ...prvState, searchText: searchterm, transSearch: searchterm }));
   }, [setState]);
   const setTransSearchText: any = useCallback((transSearch: string) => {
      setState((prvState: any) => ({ ...prvState, transSearch: transSearch }));
   }, [setState]);
   const setSearchFilterOn: any = useCallback((searchFilterOn: boolean) => {
      setState((prvState: any) => ({ ...prvState, searchFilterOn: searchFilterOn }));
   }, [setState]);

   const setNotesData = useCallback((newData: any) => {
      setState((prvState: any) => ({ ...prvState, notesData: newData}));
    }, [setState]);
   const setIsOpenTranscriptComment: any = useCallback((isOpenTranscriptComment: boolean) => {
      setState((prvState: any) => ({...prvState, isOpenTranscriptComment: isOpenTranscriptComment}))
   }, [setState]);

   const setMeetingSearchTerms: any = useCallback((searchterm: any) => {
      setState((prvState: any) => ({
         ...prvState,
         meetingSearchTerms: searchterm,
      }));
   }, [setState]);
   const setHideMiddlePanel: any = useCallback((hide: boolean) => {
      setState((prvState: any) => ({ ...prvState, hideMiddlePanel: hide }));
   }, [setState]);
   const setHideRightPanel: any = useCallback((hide: boolean) => {
      setState((prvState: any) => ({ ...prvState, hideRightPanel: hide }));
   }, [setState]);
   const setHideContentPanel: any = useCallback((hide: boolean) => {
      setState((prvState: any) => ({ ...prvState, hideContentPanel: hide }));
   }, [setState]);
   const setHideContentHeaderPanel: any = useCallback((hide: boolean) => {
      setState((prvState: any) => ({
         ...prvState,
         hideContentHeaderPanel: hide,
      }));
   }, [setState]);
   const setHideMeetingPanel: any = useCallback((hide: boolean) => {
      setState((prvState: any) => ({ ...prvState, hideMeetingPanel: hide }));
   }, [setState]);
   const setMeetingHiddenColumns: any = useCallback((meetingHiddenColumns: string[]) => {
      setState((prvState: any) => ({
         ...prvState,
         meetingHiddenColumns: meetingHiddenColumns,
      }));
   }, [setState]);
   const setLoading: any = useCallback((hide: boolean) => {
      setState((prvState: any) => ({ ...prvState, loading: hide }));
   }, [setState]);
   const setCurrentLeftTab: any = useCallback((tab: string) => {
      setState((prvState: any) => ({ ...prvState, currentLeftTab: tab }));
   }, [setState]);
   const setVideoFullExpanded: any = useCallback((expand: boolean) => {
      setState((prvState: any) => ({ ...prvState, videoFullExpanded: expand }));
   }, [setState]);
   const setTranscriptRow: any = useCallback((showTab: boolean) => {
      setState((prvState: any) => ({ ...prvState, transcriptRow: showTab }));
   }, [setState]);

   const setLoadingMeetingCount = useCallback((loading: boolean) => {
      setState((prvState: any) => ({ ...prvState, loadingMeetingCount: loading }));
   }, [setState]);

   const setEditCommentId = useCallback((id: string) => {
      setState((prvState: any) => ({...prvState, editCommentId: id }));
   }, [setState]);

   return {
      searchText: state.searchText,
      setSearchText,
      transSearch: state.transSearch,
      setTransSearchText,
      searchFilterOn: state.searchFilterOn,
      setSearchFilterOn,
      meetingSearchTerms: state.meetingSearchTerms,
      setMeetingSearchTerms,
      hideContentHeaderPanel: state.hideContentHeaderPanel,
      hideContentPanel: state.hideContentPanel,
      hideMeetingPanel: state.hideMeetingPanel,
      expandLeftPanel: state.expandLeftPanel,
      hideMiddlePanel: state.hideMiddlePanel,
      hideRightPanel: state.hideRightPanel,
      meetingHiddenColumns: state.meetingHiddenColumns,
      showSearchPanel: state.showSearchPanel,
      showNavSearchPanel: state.showNavSearchPanel,
      loading: state.loading,
      currentLeftTab: state.currentLeftTab,
      setCurrentLeftTab,
      setLoading,
      setMeetingHiddenColumns,
      setExpandLeftPanel,
      setHideMiddlePanel,
      setShowSearchPanel,
      setHideRightPanel,
      setHideContentPanel,
      setHideMeetingPanel,
      setHideContentHeaderPanel,
      setFilterTopNav,
      isFilterTopNav: state.isFilterTopNav,
      setExtraLeftPanel,
      showExtraLeftPanel: state.showExtraLeftPanel,
      setIsOpenTranscriptComment,
      isOpenTranscriptComment:state.isOpenTranscriptComment,
      notesData: state.notesData,
      setNotesData,
      videoFullExpanded: state.videoFullExpanded,
      setVideoFullExpanded,
      transcriptRow: state.transcriptRow,
      setTranscriptRow,
      loadingMeetingCount: state.loadingMeetingCount,
      setLoadingMeetingCount,
      editCommentId: state.editCommentId,
      setEditCommentId
   };
};

export default useBehaviourContext;
